<template>
  <div>
    <b-row>
      <div class="d-flex flex-wrap w-100">
        <b-col cols="12">
          <span class="text-muted font-weight-bolder"
            >Races >10 mins to start</span
          >
        </b-col>

        <b-col v-if="isLoading" class="d-flex w-100" style="gap: 12px">
          <div v-for="i in 8" :key="i" class="w-100 border rounded p-1">
            <b-skeleton width="60%" height="14px" class="mb-1" />
            <b-skeleton width="80%" height="14px" class="mb-2" />

            <b-skeleton width="100%" height="12px" class="mb-1" />
            <b-skeleton width="70%" height="12px" class="mb-1" />
            <b-skeleton width="90%" height="12px" />
          </div>
        </b-col>

        <b-col
          v-else
          style="
            flex: 0 0 calc(100% / 8);
            max-width: calc(100% / 8);
            margin-bottom: 8px;
            padding: 4px;
          "
          v-for="race in racesMore10Mins"
          :key="race.name"
        >
          <b-card
            class="mb-0 h-100"
            no-body
            border-variant="secondary"
            style="border-radius: 6px; padding: 4px"
          >
            <b-link
              :to="`/trading/racing/view/${race.meetingId}?raceId=${race.raceId}`"
              class="text-body"
            >
              <div
                class="d-flex align-items-start justify-content-between"
                style="gap: 4px"
              >
                <div class="d-flex flex-column">
                  <strong style="font-size: 12px">R{{ race.eventNo }} </strong>
                  <strong style="font-size: 12px">{{ race.venueName }}</strong>
                </div>
                <small>{{ format(new Date(race.utcTime), "hh:mm") }}</small>
              </div>
              <div
                class="d-flex align-items-start justify-content-between"
                style="gap: 4px"
              >
                <span class="text-muted" style="font-size: 10px">
                  HOLD:
                  <strong>{{ formatCurrencyBuiltInFunc(race.hold) }}</strong>
                </span>
                <span class="text-muted" style="font-size: 12px">
                  {{ race.distance }}</span
                >
              </div>

              <div
                class="d-flex align-items-start justify-content-between flex-wrap"
                style="gap: 4px"
              >
                <span class="text-muted" style="font-size: 10px"
                  >LIAB:
                  <strong class="text-success">{{
                    formatCurrencyBuiltInFunc(race.totalLiability || 0)
                  }}</strong></span
                >
                <span class="text-muted" style="font-size: 10px"
                  >EXOTICS:
                  <strong>{{
                    formatCurrencyBuiltInFunc(race.totalExoticStake || 0)
                  }}</strong></span
                >
              </div>
            </b-link>
          </b-card>
        </b-col>
      </div>
    </b-row>

    <b-row>
      <div class="d-flex flex-wrap w-100">
        <b-col cols="12">
          <span class="text-muted font-weight-bolder"
            >Races &lt;10 mins to start</span
          >
        </b-col>
        <b-col v-if="isLoading" class="d-flex w-100" style="gap: 12px">
          <div v-for="i in 8" :key="i" class="w-100 border rounded p-1">
            <b-skeleton width="60%" height="14px" class="mb-1" />
            <b-skeleton width="80%" height="14px" class="mb-2" />

            <b-skeleton width="100%" height="12px" class="mb-1" />
            <b-skeleton width="70%" height="12px" class="mb-1" />
            <b-skeleton width="90%" height="12px" />
          </div>
        </b-col>
        <b-col
          v-else
          style="
            flex: 0 0 calc(100% / 8);
            max-width: calc(100% / 8);
            margin-bottom: 8px;
            padding: 4px;
          "
          v-for="race in racesLess10Mins"
          :key="race.name"
        >
          <b-card
            class="mb-0 h-100"
            no-body
            border-variant="secondary"
            style="
              border-radius: 6px;
              padding: 4px;
              border: 1px solid #ffd7a8 !important;
              background: #fff7ed;
            "
          >
            <b-link
              :to="`/trading/racing/view/${race.meetingId}?raceId=${race.raceId}`"
              class="text-body"
            >
              <div
                class="d-flex align-items-start justify-content-between"
                style="gap: 4px"
              >
                <div class="d-flex flex-column">
                  <strong style="font-size: 12px">R{{ race.eventNo }} </strong>
                  <strong style="font-size: 12px">{{ race.venueName }}</strong>
                </div>
                <small>{{ format(new Date(race.utcTime), "hh:mm") }}</small>
              </div>
              <div
                class="d-flex align-items-start justify-content-between"
                style="gap: 4px"
              >
                <span class="text-muted" style="font-size: 10px">
                  HOLD:
                  <strong>{{ formatCurrencyBuiltInFunc(race.hold) }}</strong>
                </span>
                <span class="text-muted" style="font-size: 12px">
                  {{ race.distance }}</span
                >
              </div>

              <div
                class="d-flex align-items-start justify-content-between flex-wrap"
                style="gap: 4px"
              >
                <span class="text-muted" style="font-size: 10px"
                  >LIAB:
                  <strong class="text-warning">{{
                    formatCurrencyBuiltInFunc(race.totalLiability)
                  }}</strong></span
                >
                <span class="text-muted" style="font-size: 10px"
                  >EXOTICS:
                  <strong>{{
                    formatCurrencyBuiltInFunc(race.totalExoticStake)
                  }}</strong></span
                >
              </div>
            </b-link>
          </b-card>
        </b-col>
      </div>
    </b-row>

    <b-row class="mt-1">
      <b-col
        cols="12"
        class="d-flex align-items-center flex-wrap justify-content-between"
      >
        <div class="d-flex align-items-center" style="gap: 16px">
          <b-button
            size="sm"
            variant="outline-secondary"
            class="font-weight-bolder text-body"
            to="/trading"
          >
            <feather-icon icon="ArrowLeftIcon" />
            Back to Dashboard
          </b-button>
          <h4 class="mb-0">All Racing</h4>
          <div class="d-flex align-items-center" style="gap: 6px">
            <feather-icon
              icon="ChevronLeftIcon"
              size="16"
              style="color: #99a1af"
              class="cursor-pointer"
              @click="handleMinusDay()"
            />
            <p class="mb-0 p-0 cursor-pointer" style="color: #4a5565">
              <flat-pickr
                id="activeDay"
                v-model="activeDay"
                style="width: 100px; border: none; text-align: center"
              />
            </p>
            <feather-icon
              icon="ChevronRightIcon"
              size="16"
              style="color: #99a1af"
              class="cursor-pointer"
              @click="handleAddDay()"
            />
          </div>
        </div>

        <div>
          <!-- <b-form-checkbox-group>
            <b-form-checkbox>Hide Odds</b-form-checkbox>
            <b-form-checkbox>Global</b-form-checkbox>
            <b-form-checkbox>Fixed Odds</b-form-checkbox>
          </b-form-checkbox-group> -->

          <b-button variant="primary" @click="$bvModal.show('protest-payout')">
            Protest Payout Activity
          </b-button>

          <ProtestPayoutActivity />

          <!-- <b-button
            class="ml-1"
            variant="outline-secondary"
            @click="$bvModal.show('race-config')"
          >
            Config Race Time
          </b-button>
          <RaceConfigModal /> -->
          <b-button
            class="ml-1"
            variant="outline-secondary"
            @click="openModalChangeMeetingOrder"
          >
            Change Track Ordering
          </b-button>
          <b-button
            class="ml-1"
            variant="outline-secondary"
            @click="openViewMoreFutures"
          >
            View Meeting Futures
          </b-button>
        </div>
      </b-col>
      <b-col
        cols="12"
        class="mt-1 d-flex align-items-center flex-wrap"
        style="gap: 8px"
      >
        <b-button
          v-for="(item, ind) in listFilterTime"
          @click="handleChangeTime(item, ind)"
          :key="item"
          size="sm"
          :variant="activeTime === item ? 'dark' : 'outline-secondary'"
          >{{ item }}</b-button
        >
      </b-col>
      <b-col
        cols="12"
        class="mt-1 d-flex align-items-center flex-wrap"
        style="gap: 8px"
      >
        <b-button
          v-for="item in listMeetingType"
          :key="item"
          size="sm"
          :variant="activeMeetingType === item ? 'dark' : 'outline-secondary'"
          @click="activeMeetingType = item"
          >{{ item }}</b-button
        >

        <div class="meeting-search ml-auto">
          <b-input-group size="sm">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="searchMeetingKeyword"
              placeholder="Search meeting..."
              autocomplete="off"
              @input="handleSearchMeeting"
              @focus="showMeetingSearchResult = !!searchMeetingKeyword"
              @blur="showMeetingSearchResult = false"
              @keydown.esc="showMeetingSearchResult = false"
            />
            <b-input-group-append v-if="searchMeetingKeyword">
              <button
                type="button"
                class="input-group-text cursor-pointer"
                title="Clear search"
                @mousedown.prevent="clearSearchMeeting"
              >
                <feather-icon icon="XIcon" />
              </button>
            </b-input-group-append>
          </b-input-group>

          <div
            v-if="showMeetingSearchResult"
            class="meeting-search-result border rounded shadow-sm bg-white"
          >
            <div v-if="loadingSearchMeetings" class="p-1">
              <b-skeleton v-for="i in 3" :key="i" width="100%" height="14px" />
            </div>
            <small
              v-else-if="searchMeetingResults.length === 0"
              class="d-block p-1 text-muted"
              >No meetings found</small
            >
            <template v-else>
              <div
                v-for="meeting in searchMeetingResults"
                :key="meeting.meetingId"
                class="meeting-search-item d-flex align-items-center justify-content-between px-1 py-50"
                :class="{
                  'bg-light-primary':
                    venuesActive && venuesActive.meetingId === meeting.meetingId,
                }"
                @mousedown.prevent="selectSearchedMeeting(meeting)"
              >
                <span class="font-weight-bold">{{ meeting.venueName }}</span>
                <small class="text-muted">
                  {{
                    [meeting.meetingType, meeting.countryCode || meeting.country]
                      .filter(Boolean)
                      .join(" · ")
                  }}
                </small>
              </div>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <p class="text-body font-weight-bolder mb-0">Aus/NZ</p></b-col
      >
      <b-col cols="12" v-if="loadingMeetings">
        <b-skeleton class="mb-0" width="100%" height="60px"></b-skeleton>
      </b-col>
      <template v-else>
        <b-col cols="12" v-if="meetingAusNZ.length === 0">
          <small>No venues available</small>
        </b-col>
        <b-col
          v-else
          v-for="(venue, index) in meetingAusNZ"
          :key="index"
          cols="3"
          md="2"
          xl="1"
          style="padding: 0 5px"
        >
          <div class="d-flex flex-column align-items-center">
            <small>{{ index + 1 }}</small>
            <b-button
              v-if="venuesActive"
              size="sm"
              :variant="
                venuesActive.meetingId === venue.meetingId
                  ? 'primary'
                  : 'outline-secondary'
              "
              class="venue-button"
              style="width: 100%; padding: 0 4px"
              @click="venuesActive = venue"
            >
              {{ venue.venueName }}
            </b-button>
          </div>
        </b-col>
      </template>
    </b-row>

    <b-row>
      <b-col cols="12">
        <p class="text-body font-weight-bolder mb-0">INT</p></b-col
      >
      <b-col cols="12" v-if="loadingMeetings">
        <b-skeleton class="mb-0" width="100%" height="60px"></b-skeleton>
      </b-col>

      <template v-else>
        <b-col cols="12" v-if="meetingInt.length === 0">
          <small>No venues available</small>
        </b-col>
        <b-col
          v-else
          v-for="(venue, index) in meetingInt"
          :key="index"
          cols="3"
          md="2"
          xl="1"
          style="padding: 0 5px"
        >
          <div class="d-flex flex-column align-items-center">
            <small>{{ index + 1 }}</small>

            <b-button
              v-if="venuesActive"
              size="sm"
              :variant="
                venuesActive.meetingId === venue.meetingId
                  ? 'primary'
                  : 'outline-secondary'
              "
              class="venue-button"
              style="width: 100%; padding: 0 4px"
              @click="venuesActive = venue"
            >
              {{ venue.venueName }}
            </b-button>
          </div>
        </b-col>
      </template>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card class="rounded">
          <div v-if="venuesActive">
              <div class="d-flex justify-content-between">
                <div>
                  <span class="font-weight-bold">{{
                    venuesActive.venueName
                  }}</span>
                  <span class="ml-1 text-muted">Track Condition: Good </span>
                  <span v-if="venuesActive.meetingWeather"
                    >Weather: {{ venuesActive.meetingWeather }}</span
                  >
                </div>
                <!-- <b-button
                  size="sm"
                  :variant="isCurrentVenueDisabled ? 'success' : 'danger'"
                  class="ml-1"
                  @click="$bvModal.show('toggle-meeting-modal')"
                >
                  {{ isCurrentVenueDisabled ? "Enable Meeting" : "Disable Meeting" }}
                </b-button> -->
                   <div class="d-flex flex-wrap" style="gap: 6px">
                <b-button
                  size="sm"
                  :variant="
                    !venuesActive.isAllowedPlaceBetting ? 'success' : 'danger'
                  "
                  @click="$bvModal.show('toggle-meeting-modal')"
                >
                  {{
                    !venuesActive.isAllowedPlaceBetting
                      ? "Enable Meeting"
                      : "Disable Meeting"
                  }}
                </b-button>
                <b-button
                  size="sm"
                  :variant="isCurrentVenueDisabled ? 'success' : 'danger'"
                  @click="$bvModal.show('toggle-crawling-modal')"
                >
                  {{
                    !isCurrentVenueDisabled
                      ? "Stop Crawling"
                      : "Enable Crawling"
                  }}
                </b-button>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="openListIgnoredCrawlingModal"
                >
                  Crawling Ignored Meetings
                </b-button>
              </div>
              </div>
              <div class="mb-1">
                <span
                  >Show Fixed available:
                  {{
                    venuesActive.fixedOddsTime
                      ? format(
                          new Date(venuesActive.fixedOddsTime),
                          "yyyy-MM-dd hh:mm:ss"
                        )
                      : "--"
                  }}</span
                >
                <b-button
                  size="sm"
                  variant="primary"
                  class="ml-1"
                  @click="openModalChangeTime"
                  >Change Time</b-button
                >
              </div>
            </div>

          <b-table
            :items="listActiveRaces"
            :fields="fields"
            small
            responsive
            @row-clicked="onRowClicked"
            class="cursor-pointer"
          >
            <template #empty>
              <div v-if="loadingRaces" class="text-center text-dark my-2">
                <p>Loading... Please wait</p>
              </div>

              <div
                v-else-if="!loadingRaces && listActiveRaces.length === 0"
                class="text-center text-dark my-2"
              >
                No matching records found
              </div>
            </template>
            <template #cell(eventNo)="{ item }">
              <div class="d-flex">
                <span>{{ item.raceId }}</span>
              </div>
            </template>
            <template #cell(betTypes)="row">
              <b-button
                size="md"
                variant="outline"
                @click="row.toggleDetails"
                class="text-nowrap p-0"
                style="font-size: 14px"
              >
                {{ formatBetTypes(row.item.betTypeConfig.rules).length || 0 }}
                <feather-icon
                  v-if="formatBetTypes(row.item.betTypeConfig.rules).length > 0"
                  icon="ChevronDownIcon"
                  :class="row.item.detailsShowing ? 'rotate-180' : ''"
                  style="transition: transform 0.3s"
                />
              </b-button>
            </template>
            <template #row-details="row">
              <b-card body-class="p-0">
                <div class="d-flex flex-wrap" style="gap: 4px">
                  <span
                    v-if="!formatBetTypes(row.item.betTypeConfig.rules).length"
                    >-</span
                  >
                  <b-button
                    v-for="i in formatBetTypes(row.item.betTypeConfig.rules)"
                    :key="i"
                    size="sm"
                    variant="secondary"
                    class="mr-1"
                    disabled
                    >{{ i }}</b-button
                  >
                </div>
              </b-card>
            </template>
            <template #cell(time)="{ item }">
              <span>{{ format(new Date(item.utcTime), "HH:mm") }}</span>
            </template>
            <template #cell(totalRunner)="{ item }">
              <span>{{ item.totalRunner }}</span>
            </template>

            <template #cell(eventName)="{ item }">
              <span>{{ item.eventName + ` - ${item.distance}m` }}</span>
            </template>
            <template #cell(fixedHold)="{ item }">
              <span>{{ formatCurrencyBuiltInFunc(item.fixedHold) }}</span>
            </template>
            <template #cell(bonusHold)="{ item }">
              <span>{{ formatCurrencyBuiltInFunc(item.fixedHoldBonus) }}</span>
            </template>
            <template #cell(othersHold)="{ item }">
              <span>{{ formatCurrencyBuiltInFunc(item.hold) }}</span>
            </template>
            <template #cell(liability)="{ item }">
              <span>{{ formatCurrencyBuiltInFunc(item.totalLiability) }}</span>
            </template>
            <template #cell(result)>
              <span>{{ "-" }}</span>
            </template>

            <template #cell(placings)="{ item }">
              <span>{{ item.placings || "-" }}</span>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="fix-time-modal"
      hide-footer
      centered
      size="sm"
      title="Fixed Time"
    >
      <div class="text-black">
        <validation-observer ref="formFixedTime">
          <b-form>
            <validation-provider
              #default="{ errors }"
              name="fixed odds time"
              rules="required"
            >
              <b-form-group label="Show Fixed Time">
                <flat-pickr
                  v-model="form.fixedOddsTime"
                  class="form-control"
                  :config="configDate"
                  placeholder="mm/dd/yyyy"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-form>
        </validation-observer>
      </div>
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="$bvModal.hide('fix-time-modal')"
        >
          Cancel
        </b-button>

        <b-button variant="success" @click="submitChangeTime"> Save </b-button>
      </div>
    </b-modal>

  
    <!-- TOGGLE DISABLE/ENABLE MEETING -->
    <b-modal
      id="toggle-meeting-modal"
      hide-footer
      centered
      size="sm"
      :title="!venuesActive.isAllowedPlaceBetting ? 'Enable Meeting' : 'Disable Meeting'"
    >
      <p class="text-body">
        Are you sure you want to
        <strong>{{ !venuesActive.isAllowedPlaceBetting ? "enable" : "disable" }}</strong>
        meeting <strong>{{ venuesActive && venuesActive.venueName }}</strong
        >?
      </p>
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="$bvModal.hide('toggle-meeting-modal')"
        >
          Cancel
        </b-button>
        <b-button
          :variant="!venuesActive.isAllowedPlaceBetting ? 'success' : 'danger'"
          :disabled="loadingDisableMeeting"
          @click="handleToggleMeeting"
        >
          {{ !venuesActive.isAllowedPlaceBetting ? "Enable" : "Disable" }}
        </b-button>
      </div>
    </b-modal>

    <!-- TOGGLE CRAWLING MEETING -->
    <b-modal
      id="toggle-crawling-modal"
      hide-footer
      centered
      size="sm"
      :title="isCurrentVenueDisabled ? 'Enable Crawling' : 'Stop Crawling'"
    >
      <p class="text-body">
        Are you sure you want to
        <strong>{{
          isCurrentVenueDisabled ? "enable crawling for" : "stop crawling"
        }}</strong>
        meeting <strong>{{ venuesActive && venuesActive.venueName }}</strong
        >?
      </p>
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="$bvModal.hide('toggle-crawling-modal')"
        >
          Cancel
        </b-button>
        <b-button
          :variant="isCurrentVenueDisabled ? 'success' : 'danger'"
          :disabled="loadingDisableMeeting"
          @click="handleToggleCrawling"
        >
          {{ isCurrentVenueDisabled ? "Enable" : "Stop" }}
        </b-button>
      </div>
    </b-modal>

    <!-- LIST MEETING IGNORED CRAWLING -->
    <b-modal
      id="list-ignored-crawling-modal"
      hide-footer
      centered
      size="lg"
      title="Crawling Ignored Meetings"
    >
      <div v-if="loadingIgnoredCrawling" class="text-center py-3">
        <b-spinner small class="mr-1" />
        Loading...
      </div>
      <b-table
        v-else
        :items="listDisabledMeetings"
        :fields="[
          { key: 'venueName', label: 'Venue Name' },
          { key: 'actions', label: 'Action' },
        ]"
        responsive
        show-empty
        empty-text="No meetings ignored crawling"
      >
        <template #cell(actions)="{ item }">
          <b-button
            size="sm"
            variant="outline-danger"
            @click="confirmEnableCrawling(item)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>
      </b-table>
    </b-modal>

    <!-- CONFIRM ENABLE CRAWLING FROM LIST -->
    <b-modal
      id="confirm-enable-crawling-modal"
      hide-footer
      centered
      size="sm"
      title="Enable Crawling"
    >
      <p class="text-body">
        Are you sure you want to enable crawling for meeting
        <strong>{{
          selectedIgnoredMeeting && selectedIgnoredMeeting.venueName
        }}</strong
        >?
      </p>
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="$bvModal.hide('confirm-enable-crawling-modal')"
        >
          Cancel
        </b-button>
        <b-button
          variant="success"
          :disabled="loadingEnableCrawling"
          @click="handleEnableCrawlingFromList"
        >
          Enable
        </b-button>
      </div>
    </b-modal>

    <!-- CHANGE ORDER MEETING -->
    <b-modal
      id="track-ordering"
      hide-footer
      centered
      size="xl"
      title="Change Track Ordering"
    >
      <div class="text-black">
        <b-row class="d-flex justify-content-end mb-1 mr-1">
          <b-button variant="outline-secondary" @click="handleCancelReorder"
            >Cancel</b-button
          >
          <b-button
            class="ml-1"
            variant="primary"
            @click="handleSaveNewOrdering"
            >Save New Ordering</b-button
          >
        </b-row>
        <b-row>
          <b-col cols="12" md="6">
            <h5>Aus/NZ</h5>
            <p class="text-muted m-0">
              <feather-icon icon="MoveIcon" class="mr-1" />
              Drag to reorder display priority
            </p>
            <draggable
              v-if="newOrderAusNzList.length > 0"
              :list="newOrderAusNzList"
              :group="{ name: 'groups-aus' }"
              :sort="true"
            >
              <div
                v-for="(meeting, index) in newOrderAusNzList"
                :key="meeting.meetingId"
                class="d-flex align-items-center justify-content-between p-1"
                :class="{
                  'border-bot': index !== newOrderAusNzList.length - 1,
                }"
                style="cursor: pointer; gap: 16px"
              >
                <div>
                  <feather-icon icon="AlignCenterIcon" class="text-muted" />
                  {{ index + 1 }}, {{ meeting.venueName }}
                </div>
              </div>
            </draggable>
          </b-col>
          <b-col cols="12" md="6">
            <h5>INT</h5>
            <p class="text-muted m-0">
              <feather-icon icon="MoveIcon" class="mr-1" />
              Drag to reorder display priority
            </p>
            <draggable
              v-if="newOrderIntList.length > 0"
              :list="newOrderIntList"
              :group="{ name: 'groups-int' }"
              :sort="true"
            >
              <div
                v-for="(meeting, index) in newOrderIntList"
                :key="meeting.meetingId"
                class="d-flex align-items-center justify-content-between p-1"
                :class="{
                  'border-bot': index !== newOrderIntList.length - 1,
                }"
                style="cursor: pointer; gap: 16px"
              >
                <div>
                  <feather-icon icon="AlignCenterIcon" class="text-muted" />
                  {{ index + 1 }}, {{ meeting.venueName }}
                </div>
              </div>
            </draggable>
          </b-col>
        </b-row>
        <b-row class="d-flex justify-content-end mb-1 mt-2 mr-1">
          <b-button variant="outline-secondary" @click="handleCancelReorder"
            >Cancel</b-button
          >
          <b-button
            class="ml-1"
            variant="primary"
            @click="handleSaveNewOrdering"
            >Save New Ordering</b-button
          >
        </b-row>
      </div>
    </b-modal>

    <b-modal
      id="view-more-futures"
      title="Future Meetings"
      size="lg"
      centered
      scrollable
      hide-footer
    >
      <div class="vmf-toolbar">
        <feather-icon icon="CalendarIcon" size="16" class="vmf-toolbar__icon" />
        <flat-pickr
          v-model="futuresDate"
          class="form-control vmf-datepicker"
          :config="configFuturesDate"
        />
      </div>

      <div v-if="loadingFuturesMeetings" class="vmf-skeletons">
        <b-skeleton width="100%" height="44px" />
        <b-skeleton width="100%" height="44px" />
        <b-skeleton width="100%" height="44px" />
      </div>
      <div v-else-if="futuresMeetings.length === 0" class="vmf-empty">
        <feather-icon icon="InboxIcon" size="28" />
        <span>No future meetings for this date</span>
      </div>
      <div v-else class="vmf-list">
        <button
          v-for="race in sortedFuturesMeetings"
          :key="'vmf-race-' + race.raceId"
          type="button"
          class="vmf-race"
          @click="goToFuturesRace(race)"
        >
          <span class="vmf-race__venue">{{ race.venueName }}</span>
          <span class="vmf-race__name">{{ race.eventName }}</span>
          <b-badge
            v-if="race.finalStatus"
            :variant="futuresStatusVariant(race.finalStatus)"
            class="vmf-race__status"
            >{{ race.finalStatus }}</b-badge
          >
          <feather-icon
            icon="ChevronRightIcon"
            size="14"
            class="vmf-race__arrow"
          />
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BLink,
  BContainer,
  BFormCheckbox,
  BFormCheckboxGroup,
  BSkeleton,
  BBadge,
  BModal,
  BFormGroup,
  BForm,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import {
  addDays,
  endOfDay,
  format,
  startOfDay,
  subDays,
  addMinutes,
} from "date-fns";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ProtestPayoutActivity from "./ProtestPayoutActivity.vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import RaceConfigModal from "./view/modals/RaceConfigModal.vue";
import draggable from "vuedraggable";
import debounce from "lodash/debounce";

export default {
  components: {
    BContainer,
    BButton,
    BCard,
    BCol,
    BPagination,
    BRow,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BMedia,
    BAvatar,
    BLink,
    vSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    FeatherIcon,
    BSkeleton,
    BBadge,
    BModal,
    flatPickr,
    BFormGroup,
    ValidationObserver,
    ValidationProvider,
    BForm,
    ProtestPayoutActivity,
    RaceConfigModal,
    draggable,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
  },
  data() {
    return {
      listFilterTime: ["Today", "Tomorrow"],
      activeTime: "Today",
      activeDay: format(new Date(), "yyyy-MM-dd"),
      venuesActive: null,
      listMeetingType: ["All", "T", "G", "H"],
      activeMeetingType: "All",
      fields: [
        { key: "eventNo", label: "Race" },
        { key: "time", label: "Time" },
        { key: "eventName", label: "Event name" },
        { key: "totalRunner", label: "Runners" },
        { key: "betTypes", label: "Bet Types" },
        { key: "fixedHold", label: "Fixed Hold (W/P)" },
        { key: "bonusHold", label: "Bonus Hold (W/P)" },
        { key: "othersHold", label: "Others Hold" },
        { key: "liability", label: "Liability" },
        { key: "result", label: "Result" },
        { key: "placings", label: "Placings" },
      ],
      listActiveRaces: [],
      meetingAusNZ: [],
      meetingInt: [],
      form: {
        fixedOddsTime: null,
      },
      configDate: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:ss",
        enableSeconds: true,
        static: true,
      },
      configFuturesDate: {
        dateFormat: "Y-m-d",
      },
      futuresDate: format(new Date(), "yyyy-MM-dd"),
      futuresMeetings: [],
      loadingFuturesMeetings: false,
      racesLess10Mins: [],
      racesMore10Mins: [],
      isLoading: false,
      newOrderAusNzList: [],
      newOrderIntList: [],
      listDisabledMeetings: [],
      loadingIgnoredCrawling: false,
      selectedIgnoredMeeting: null,
      loadingEnableCrawling: false,
      loadingFeatureMeeting: false,
      searchMeetingKeyword: "",
      searchMeetingResults: [],
      showMeetingSearchResult: false,
      loadingSearchMeetings: false,
    };
  },
  watch: {
    futuresDate() {
      this.fetchFuturesMeetings();
    },
    activeMeetingType(val) {
      this.handleGetListMeetings();
    },
    activeDay(val) {
      this.handleGetListMeetings();
      this.checkActiveDay(val);
      this.clearSearchMeeting();
    },
    async venuesActive(val) {
      await this.fetchListRacesOfMeeting();
    },
  },
  async mounted() {
    this.listFilterTime.push(...this.getNext5DaysOfTomorrow);
    await Promise.allSettled([
      this.handleGetListMeetings(),
      this.fetchRacesByRangeTime(),
      this.fetchDisabledMeetings(),
    ]);
  },
  computed: {
    ...mapState("trading/racing", ["loadingMeetings", "loadingRaces", "loadingDisableMeeting"]),
    sortedFuturesMeetings() {
      return [...this.futuresMeetings].sort(
        (a, b) =>
          (a.venueName || "").localeCompare(b.venueName || "") ||
          (a.eventName || "").localeCompare(b.eventName || "")
      );
    },
    isCurrentVenueDisabled() {
      if (!this.venuesActive) return false;
      return this.listDisabledMeetings.some(
        (m) => m.venueName === this.venuesActive.venueName
      );
    },
    currentDisabledMeetingRecord() {
      if (!this.venuesActive) return null;
      return this.listDisabledMeetings.find(
        (m) => m.venueName === this.venuesActive.venueName
      ) || null;
    },
    getNext5DaysOfTomorrow() {
      const weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const results = [];

      const todayIndex = new Date().getDay();

      for (let i = 2; i <= 6; i++) {
        const nextDayIndex = (todayIndex + i) % 7;
        results.push(weekdays[nextDayIndex]);
      }

      return results;
    },
  },
  methods: {
    ...mapActions({
      getListMeetings: "trading/racing/getListMeetings",
      getRacesOfMeeting: "trading/racing/getRacesOfMeeting",
      changeFixedTime: "trading/racing/updateMeeting",
      getRaceByRangeTime: "trading/racing/getRaceByRangeTime",
      updateMeetingOrdering: "trading/racing/updateMeetingOrdering",
      getAllListDisabledMeeting: "trading/racing/getAllListDisabledMeeting",
      disableMeeting: "trading/racing/disableMeeting",
      enableMeeting: "trading/racing/enableMeeting",
      searchMeetings: "trading/racing/searchMeetings",
      getFutureMeetings: "trading/racing/getFutureMeetings",
    }),
    format,
    formatCurrencyBuiltInFunc,
    onRowClicked(item) {
      this.$router.push(
        `/trading/racing/view/${item.meetingId}?raceId=${item.raceId}`
      );
    },
    async openViewMoreFutures() {
      this.futuresDate = format(new Date(), "yyyy-MM-dd");
      this.$bvModal.show("view-more-futures");
      await this.fetchFuturesMeetings();
    },
    async fetchFuturesMeetings() {
      this.loadingFuturesMeetings = true;
      try {
        const res = await this.getFutureMeetings({
          limit: 100,
          meetingDateFrom: startOfDay(new Date(this.futuresDate)).toISOString(),
          meetingDateTo: endOfDay(new Date(this.futuresDate)).toISOString(),
        });
        this.futuresMeetings = res || [];
      } finally {
        this.loadingFuturesMeetings = false;
      }
    },
    goToFuturesRace(race) {
      this.$router.push(
        `/trading/racing/view/${race.meetingId}?raceId=${race.raceId}&type=future`
      );
    },
    futuresStatusVariant(status) {
      switch (status) {
        case "FINAL":
          return "light-success";
        case "OPEN":
          return "light-primary";
        case "ABANDONED":
          return "light-danger";
        default:
          return "light-secondary";
      }
    },
    handleChangeTime(time, ind) {
      if (ind === 0) {
        this.activeDay = format(new Date(), "yyyy-MM-dd");
      } else {
        this.activeDay = format(addDays(new Date(), ind), "yyyy-MM-dd");
      }
    },
    async handleGetListMeetings() {
      const payload = {
        limit: 100,
        source: "RAS",
        meetingDateFrom: startOfDay(new Date(this.activeDay)).toISOString(),
        meetingDateTo: endOfDay(new Date(this.activeDay)).toISOString(),
        ...(this.activeMeetingType !== "All" && {
          meetingTypes:
            this.activeMeetingType === "T" ? "R" : this.activeMeetingType,
        }),
      };
      const [resMeetingAusNZ, resMeetingInt] = await Promise.allSettled([
        this.getListMeetings({
          ...payload,
          "countries[0]": "AU",
          "countries[1]": "NZ",
        }),
        this.getListMeetings({
          ...payload,
          isInternational: true,
        }),
      ]);
      this.meetingAusNZ =
        resMeetingAusNZ.status === "fulfilled" ? resMeetingAusNZ.value : [];
      this.meetingInt =
        resMeetingInt.status === "fulfilled" ? resMeetingInt.value : [];
      this.venuesActive = this.meetingAusNZ[0] || this.meetingInt[0] || null;
      if (this.venuesActive) {
        this.form.fixedOddsTime = this.venuesActive.fixedOddsTime;
      }
    },
    handleSearchMeeting: debounce(async function (val) {
      const keyword = val?.trim();
      // Skip calls queued before the keyword was cleared or changed
      if (keyword !== this.searchMeetingKeyword?.trim()) return;
      if (!keyword) {
        this.searchMeetingResults = [];
        this.showMeetingSearchResult = false;
        return;
      }
      this.showMeetingSearchResult = true;
      this.loadingSearchMeetings = true;
      const results = await this.searchMeetings({
        limit: 20,
        venueName: keyword,
        meetingDateFrom: startOfDay(new Date(this.activeDay)).toISOString(),
        meetingDateTo: endOfDay(new Date(this.activeDay)).toISOString(),
      });
      // Ignore stale responses if the keyword changed while waiting
      if (keyword !== this.searchMeetingKeyword?.trim()) return;
      this.searchMeetingResults = results;
      this.loadingSearchMeetings = false;
    }, 300),
    selectSearchedMeeting(meeting) {
      this.venuesActive = meeting;
      this.form.fixedOddsTime = meeting.fixedOddsTime;
      this.showMeetingSearchResult = false;
    },
    clearSearchMeeting() {
      this.searchMeetingKeyword = "";
      this.searchMeetingResults = [];
      this.showMeetingSearchResult = false;
      this.loadingSearchMeetings = false;
    },
    handleMinusDay() {
      this.activeDay = format(
        subDays(new Date(this.activeDay), 1),
        "yyyy-MM-dd"
      );
    },
    handleAddDay() {
      this.activeDay = format(
        addDays(new Date(this.activeDay), 1),
        "yyyy-MM-dd"
      );
    },
    checkActiveDay(val) {
      const today = format(new Date(), "yyyy-MM-dd");
      const tomorrow = format(addDays(new Date(), 1), "yyyy-MM-dd");
      if (val === today) {
        this.activeTime = "Today";
      } else if (val === tomorrow) {
        this.activeTime = "Tomorrow";
      } else {
        const selectedDate = new Date(val);
        const todayDate = new Date(today);
        const diffInDays = Math.round(
          (selectedDate - todayDate) / (1000 * 60 * 60 * 24)
        );
        this.activeTime = this.getNext5DaysOfTomorrow[diffInDays - 2] || "";
      }
    },
    async fetchListRacesOfMeeting() {
      if (!this.venuesActive) return;
      const res = await this.getRaceByRangeTime({
        meetingId: this.venuesActive.meetingId,
        limit: 100
      });
      this.listActiveRaces = res?.map((race) => {
        return {
          ...race,
          detailsShowing: false,
        };
      });
    },
    toggleDetails() {
      this.detailsShowing = !this.detailsShowing;
    },
    async fetchRacesByRangeTime() {
      try {
        this.isLoading = true;
        const now = new Date();
        const payload = {
          sortField: "utcTime",
          sortValue: "ASC",
        };
        const [less10Res, more10Res] = await Promise.allSettled([
          this.getRaceByRangeTime({
            ...payload,
            startDate: now.toISOString(),
            endDate: addMinutes(now, 10).toISOString(),
          }),
          this.getRaceByRangeTime({
            ...payload,
            startDate: addMinutes(now, 10).toISOString(),
            endDate: endOfDay(now).toISOString(),
          }),
        ]);
        this.racesLess10Mins =
          less10Res.status === "fulfilled" ? less10Res.value ?? [] : [];
        this.racesMore10Mins =
          more10Res.status === "fulfilled" ? more10Res.value ?? [] : [];
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    openModalChangeTime() {
      this.$bvModal.show("fix-time-modal");
    },
    async submitChangeTime() {
      const valid = await this.$refs.formFixedTime.validate();
      if (!valid) return;
      const formatTime = new Date(this.form.fixedOddsTime).toISOString();
      const result = await this.changeFixedTime({
        meetingId: this.venuesActive.meetingId,
        fixedOddsTime: formatTime,
      });
      if (result) {
        this.$bvModal.hide("fix-time-modal");
        this.showToastSuccess("Fixed time updated successfully");
        this.venuesActive = {
          ...this.venuesActive,
          fixedOddsTime: formatTime,
        };
      }
    },
    formatBetTypes(betTypes) {
      if (!betTypes) return [];
      const betTypeName = Object.keys(betTypes)
        .filter((key) => betTypes[key].enabled)
        .map((key) =>
          key.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase())
        );
      return betTypeName;
    },
    async openModalChangeMeetingOrder() {
      this.newOrderAusNzList = [...this.meetingAusNZ];
      this.newOrderIntList = [...this.meetingInt];

      this.$bvModal.show("track-ordering");
    },
    handleCancelReorder() {
      this.$bvModal.hide("track-ordering");
      this.newOrderAusNzList = [];
      this.newOrderIntList = [];
    },
    async fetchDisabledMeetings() {
      const result = await this.getAllListDisabledMeeting();
      this.listDisabledMeetings = result || [];
    },
    confirmEnableCrawling(item) {
      this.selectedIgnoredMeeting = item;
      this.$bvModal.show("confirm-enable-crawling-modal");
    },
    async handleEnableCrawlingFromList() {
      this.loadingEnableCrawling = true;
      try {
        const result = await this.enableMeeting({
          ids: [this.selectedIgnoredMeeting.id],
        });
        if (result !== undefined) {
          this.showToastSuccess("Crawling enabled successfully");
          this.$bvModal.hide("confirm-enable-crawling-modal");
          await this.fetchDisabledMeetings();
        }
      } finally {
        this.loadingEnableCrawling = false;
      }
    },
    async openListIgnoredCrawlingModal() {
      this.$bvModal.show("list-ignored-crawling-modal");
      this.loadingIgnoredCrawling = true;
      try {
        await this.fetchDisabledMeetings();
      } finally {
        this.loadingIgnoredCrawling = false;
      }
    },
    async handleToggleMeeting() {
      const meetingId = this.venuesActive.meetingId;
      const isAllowedPlaceBetting = !this.venuesActive.isAllowedPlaceBetting;
      const result = await this.changeFixedTime({
        meetingId,
        isAllowedPlaceBetting,
      });
      if (result !== undefined) {
        this.showToastSuccess(
          isAllowedPlaceBetting
            ? "Meeting enabled successfully"
            : "Meeting disabled successfully"
        );
        this.venuesActive = { ...this.venuesActive, isAllowedPlaceBetting };
        this.$bvModal.hide("toggle-meeting-modal");
      }
    },
    async handleToggleCrawling() {
      if (this.isCurrentVenueDisabled) {
        const record = this.currentDisabledMeetingRecord;
        const result = await this.enableMeeting({ ids: [record.id] });
        if (result !== undefined) {
          this.showToastSuccess("Crawling enabled successfully");
          await this.fetchDisabledMeetings();
          this.$bvModal.hide("toggle-crawling-modal");
        }
      } else {
        const result = await this.disableMeeting({
          items: [{ venueName: this.venuesActive.venueName }],
        });
        if (result !== undefined) {
          this.showToastSuccess("Crawling stopped successfully");
          await this.fetchDisabledMeetings();
          this.$bvModal.hide("toggle-crawling-modal");
        }
      }
    },
    async handleSaveNewOrdering() {
      const newList = [...this.newOrderAusNzList, ...this.newOrderIntList];
      const result = await this.updateMeetingOrdering({
        meetings: newList.map((i, index) => {
          return {
            meetingId: i.meetingId,
            orderNumber: index + 1,
          };
        }),
      });
      if (result) {
        this.showToastSuccess("Track ordering updated successfully");
        this.handleCancelReorder();
        this.handleGetListMeetings();
      }
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();

    return {
      showToastSuccess,
      showToastError,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.meeting-search {
  position: relative;
  width: 280px;
}

.meeting-search-result {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  max-height: 300px;
  overflow-y: auto;
}

.meeting-search-item {
  cursor: pointer;

  &:hover {
    background-color: #f3f4f6;
  }
}
</style>

<style lang="scss" scoped>
.card {
  border-radius: 12px;
}

.venue-button {
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-bot {
  border-bottom: 1px solid #dae1e7;
}

/* ── View More Futures modal ─────────────────── */
.vmf-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 240px;
  padding: 8px 12px;
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}
.vmf-toolbar__icon {
  flex-shrink: 0;
  color: #64748b;
}
.vmf-datepicker.form-control {
  height: auto;
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: none;
  font-weight: 600;
  color: #1e293b;
}

.vmf-skeletons {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.vmf-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 36px 0;
  color: #94a3b8;
  font-size: 13px;
}

.vmf-list {
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.vmf-race {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s;
}
.vmf-race + .vmf-race {
  border-top: 1px solid #eef2f7;
}
.vmf-race:hover {
  background: #eef2ff;
}
.vmf-race__venue {
  flex-shrink: 0;
  min-width: 140px;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}
.vmf-race__name {
  flex: 1;
  font-size: 13px;
  line-height: 1.3;
  color: #334155;
}
.vmf-race__status {
  flex-shrink: 0;
  font-size: 10px;
}
.vmf-race__arrow {
  flex-shrink: 0;
  color: #cbd5e0;
  transition: color 0.15s;
}
.vmf-race:hover .vmf-race__arrow {
  color: #6366f1;
}
</style>
